import React, { Component } from "react";
import { FormControl, Button } from "react-bootstrap";
import ReactJson from 'react-json-view';
import _ from "lodash";

import CoreService from "../../../../../../services/CoreService";


function toFixed(num, fixed) {
    var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
    return num.toString().match(re)[0];
  }
  
  let omitByDeep = (obj, shouldOmit, convertBool, convertFloat) => {
    obj = _.clone(obj);
    _.forEach(obj, (value, key) => {
      if (shouldOmit(value, key)) {
        delete obj[key];
      }
      if (convertBool) {
        if (_.isBoolean(value)) {
          obj[key] = value ? "YES" : "NO";
        }
      }
      if (convertFloat) {
        if (Number.isFinite(value)) {
          if (!Number.isInteger(value)) {
            // must be a float?
            obj[key] = toFixed(value, 2);
          }
        }
      }
      if (_.isPlainObject(value)) {
        obj[key] = omitByDeep(value, shouldOmit, convertBool, convertFloat);
      }
    });
    return obj;
  };


export default class ModalDetailPanel extends Component {
  constructor(props) {
    super(props);
    this.state =
    {
      dataSource: null
    }

  }


  async componentDidMount()
  {
    if (this.props.source === "log")
    {
      var receiptEventResult = await new CoreService().fetchReceiptEvents(this.props.userSession.gcid, this.props.currentReceipt.transactionId);
      var eventLog = (receiptEventResult.dataResult.length > 0) ? receiptEventResult.dataResult :
        {"tagId": "Log Not Available"};
      this.setState({dataSource: eventLog})
    }
    else
    {
      const displayGridRow = this.props.currentReceipt
      ? omitByDeep(
          this.props.currentReceipt,
          (v) => v === null || v === undefined || v === "" || v === 0,
          false,
          true
        ) // immutable. Will NOT change original rowData
      : {"data": {}, "score" : {}, "identifiers": {}};
      this.setState({dataSource: displayGridRow})
    }
  }


  render() 
  {


  if (this.props.currentReceipt) 
  {
    // users do not want to see OUI. I'm doing all of this JUST so I can change the label! Stupid.
    /*
    displayGridRow.data.underInspection = displayGridRow.data.oui; // again, will NOT change the original object
    delete displayGridRow.data.oui;
    delete displayGridRow.data.readOnly;
    */
  }

    return (

      <div id="detailView">

        <ReactJson 
            src = {this.state.dataSource}
            theme = "summerfruit:inverted"
            iconStyle="circle"
            enableClipboard={true}
            displayDataTypes={false}
            displayObjectSize={false}
        />


        <div style={{width: "80%", display: "flex", justifyContent: "space-evenly", borderTop: "2px solid rgb(117, 161, 255, .7)", padding: "7px"}}>
          <Button style={{minWidth: "25%"}} onClick={(ev) => this.props.onCancel(ev)}>Cancel</Button>
        </div>

      </div>
    )
  }
}